import { render, staticRenderFns } from "./ClipboardTextOutline.vue?vue&type=template&id=303a685c"
import script from "./ClipboardTextOutline.vue?vue&type=script&lang=js"
export * from "./ClipboardTextOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports